import { render, staticRenderFns } from "./CompaniesFilters.vue?vue&type=template&id=124cb5a9&scoped=true"
import script from "./CompaniesFilters.vue?vue&type=script&lang=js"
export * from "./CompaniesFilters.vue?vue&type=script&lang=js"
import style0 from "./CompaniesFilters.vue?vue&type=style&index=0&id=124cb5a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124cb5a9",
  null
  
)

export default component.exports